/**
 * @generated SignedSource<<b86c1d73489063810f9a5571143f322c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TaskFragmentStatus$data = {
  readonly statusItem: {
    readonly id: string | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"ItemFragment">;
  } | null | undefined;
  readonly " $fragmentType": "TaskFragmentStatus";
};
export type TaskFragmentStatus$key = {
  readonly " $data"?: TaskFragmentStatus$data;
  readonly " $fragmentSpreads": FragmentRefs<"TaskFragmentStatus">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskFragmentStatus",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ListItem",
      "kind": "LinkedField",
      "name": "statusItem",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ItemFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node as any).hash = "03647a6f5460cd0d50fe8d05b7a491cb";

export default node;
